import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SuperAdminSidebar from "./Components/SuperAdminSidebar";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";
import server_processing_details from "../../assets/images/server_processing_details.png";
import server_processing_details_issues from "../../assets/images/server_processing_details_issues.png";
import processing_Time_image from "../../assets/images/processing_Time_image.png";
import westside_image from "../../assets/images/westside_image.png";

const ServeProcessingDetails = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img src={hamburger_icon} className="object-contain" />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar
            categoryName="Server Processing Time"
            route="/super-admin/serve-processing-details"
          />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <SuperAdminSidebar />}
        </div>
      </div>

      <div className="ml-4 mt-6">
        <img
          src={server_processing_details}
          alt="server_processing_details"
          className="object-contain w-[60%] card--one"
        />
        <div className="flex mt-6">
          <img
            src={server_processing_details_issues}
            alt="server_processing_details_issues"
            className="w-[29%] object-contain mr-6 width-49"
          />
          <img
            src={server_processing_details_issues}
            alt="server_processing_details_issues"
            className="w-[29%] object-contain width-49"
          />
        </div>
        <img
          src={processing_Time_image}
          alt="processing_Time_image"
          className="object-contain w-[60%] mt-6 card--one"
        />
      </div>

      <div className="ml-4 my-10 bg-[#F9F9F9] p-4 w-[60%] rounded-lg card--one">
        <p className="text-[16px] font-bold">Client Details</p>
        <p className="text-[12px] mb-4">Client Interaction details</p>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
        <div className="flex justify-between items-center rounded-2xl w-[80%] shadow-md p-4 my-4 cursor-pointer">
          <div className="flex">
            <img
              src={westside_image}
              alt="westside_image"
              className="w-8 object-contain"
            />
            <p className="text-[18px] font-bold ml-2">Westside</p>
          </div>
          <p className="text-[14px] font-bold">89.7 Gb</p>
        </div>
      </div>
    </div>
  );
};

export default ServeProcessingDetails;
